import { Component } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { UserService } from 'src/app/services/user.service';
import { LoginReq } from 'src/model/User/LoginReq';
import { LoginResp } from 'src/model/User/LoginResp';
import { TranslateService } from '@ngx-translate/core';
import { startAuthSession, safeReturnUrl } from '../../auth/auth-session';

@Component({
  selector: 'app-login',
  templateUrl: './login.component.html',
  styleUrls: ['./login.component.css']
})
export class LoginComponent {
  account = '';
  password = '';
  errorMsg = '';
  showPassword = false;
  sessionMessageKey = ''; 

  constructor(
    private userService: UserService,
    private router: Router,
    private translate: TranslateService,
    private route: ActivatedRoute
  ) {
    this.sessionMessageKey = this.route.snapshot.queryParamMap.get('reason') === 'expired' ? 'LOGIN.SESSION_EXPIRED' : '';
  }
  // 按下登入按鈕時呼叫
  login() {
    this.errorMsg = '';
    const req: LoginReq = { username: this.account, password: this.password };
    this.userService.loign(req)
      .subscribe({
        next: (res: LoginResp) => {
          if (!startAuthSession(res.access_token)) {
            this.translate.get('LOGIN.ERROR').subscribe(msg => this.errorMsg = msg);
            return;
          }
          const returnUrl = safeReturnUrl(this.route.snapshot.queryParamMap.get('returnUrl'));
          if (returnUrl?.startsWith('/code')) window.location.assign(returnUrl);
          else this.router.navigateByUrl(returnUrl || '/Sync');
        },
        error: () => {
          this.translate.get('LOGIN.ERROR').subscribe(msg => this.errorMsg = msg);
        }
      });
  }
  // 按下就是顯示密碼或者不顯示密碼切換
  toggleShowPassword() {
    this.showPassword = !this.showPassword;
  }
}

